import { Typography } from '@mui/material';
import { getFinanciableInvoices } from 'lib/api/dashboard';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';
import { useDispatch } from 'react-redux';

const LastInvoicesADC: React.FC = () => {
  const dispatch = useDispatch();

  const { data: financiableInvoices, isPending: loading } =
    getFinanciableInvoices(dispatch);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <Typography variant="h5">Facturas transables</Typography>
      <EnhancedTable
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'businessName', label: 'Nombre Emisor' },
          // {key: 'businessIdentifier', label: 'Rut Emisor'},
          { key: 'stakeholderName', label: 'Nombre receptor' },
          // {key: 'stakeholderIdentifier', label: 'Rut receptor'},
          { key: 'amount', label: 'Monto', type: 'money' },
          {
            key: 'issuedDate',
            label: 'Fecha emisión',
            type: 'eight-days-date',
          },
          // {key: 'confirmDate', label: 'Fecha confirmación', type: 'date'},
          // {key: 'cancelDate', label: 'Fecha de reclamo', type: 'date-colored'},
          // {key: 'status', label: 'Estado', type: 'cession'}
        ]}
        data={financiableInvoices ?? []}
        rowsPerPageDefault={5}
      />
    </div>
  );
};

export default LastInvoicesADC;
